<div mat-dialog-content>
    <div *ngIf="open">
        <!-- <div class="viewer-content"> -->
            <a [mat-dialog-close]="false" style="color: black;">
                Fermer l'image
            </a>
            <img class="main-img" [src]="imageURL" />
        <!-- </div> -->
    </div>
</div>